import styled from "styled-components";

export const TerminalMain = styled.main`
.border{
	border-bottom: 1px solid #b7c04b;
}

.trading__together{
	color: #fff;
	& a {
		margin-top: 1.875rem;
		width: 11.563rem;
	}
}

.main__button{
	display:flex;
}

.adaptive__button{
	display: none;
}

@media(max-width:998px){
	.adaptive__button{
display: flex;
	}
	.main__button{
	display:none;
}
}
`